import * as React from 'react';
import { isEmpty } from 'lodash';

import DeliverableMoveContentMedia from './deliverable-move-content-media/DeliverableMoveContentMedia';
import ActionButton from 'components/buttons/action-button/ActionButton';
import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import {
  DataStructureComponent,
  DeliverableAttachment,
  DeliverableCustomSelectionChangeWithId,
  MixedSelectDropdownItem,
  RealmOutfit
} from 'types';

import './deliverable-move-content.scss';

applyTranslations(require('./deliverable-move-content.i18n.json'));

type OwnProps = {
  outfits?: Array<RealmOutfit>,
  attachments?: Array<DeliverableAttachment>,
  menuItems: Array<DataStructureComponent>,
  selectedDeliverableId: number | null,
  isModified: boolean,
  isContentSelected: boolean,
  onCancel: () => void,
  onChangeSelectedDeliverable: (selectedItem?: Partial<MixedSelectDropdownItem> | null) => void,
  onContentSelectionChange: DeliverableCustomSelectionChangeWithId,
  onSelectDeselectToggle: DeliverableCustomSelectionChangeWithId,
  onSave: (selectedDeliverableId: number) => void,
  onOpenMoveContent: (showMoveContent: boolean) => void
};

type Props = OwnProps;

const msgKey = 'deliverable_move_content';

class DeliverableMoveContent extends React.PureComponent<Props> {
  handleSave = () => {
    const { onSave } = this.props;
    const { selectedDeliverableId } = this.props;

    if (selectedDeliverableId) {
      onSave(selectedDeliverableId);
    }
  };

  renderCloseIcon(): React.ReactNode {
    const { onOpenMoveContent } = this.props;

    return (
      <div className="deliverable-move-content__close">
        <SVGDynamicIcon
          name="cross-custom-fg"
          width={12}
          height={12}
          onClick={() => onOpenMoveContent(false)}
          customColor="grey"
        />
      </div>
    );
  }

  renderFooter(): React.ReactNode {
    const { isContentSelected, isModified, selectedDeliverableId, onCancel, onSave } = this.props;
    const isDisabled = !(selectedDeliverableId && isContentSelected);

    return (
      <div className="deliverable-move-content__footer">
        {
          isModified && (
            <ActionButton
              color="tertiary"
              onClick={onCancel}
            >
              {__t(`${msgKey}.buttons.cancel`)}
            </ActionButton>
          )
        }
        <ActionButton
          color="primary"
          disabled={isDisabled}
          onClick={onSave}
        >
          {__t(`${msgKey}.buttons.save`)}
        </ActionButton>
      </div>
    );
  }

  renderMediaItems(): React.ReactNode {
    const { attachments, outfits, onSelectDeselectToggle, onContentSelectionChange } = this.props;

    if (isEmpty(attachments) && isEmpty(outfits)) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="deliverable-move-content__header">
          {__t(`${msgKey}.header`)}
        </div>
        <DeliverableMoveContentMedia
          outfits={outfits}
          attachments={attachments}
          onSelectionChange={onContentSelectionChange}
          onSelectDeselectToggle={onSelectDeselectToggle}
        />
      </React.Fragment>
    );
  }

  renderMenuItems(): React.ReactNode {
    const { menuItems, onChangeSelectedDeliverable } = this.props;

    return (
      <React.Fragment>
        <div className="deliverable-move-content__look-header">
          {__t(`${msgKey}.dropdown_header`)}
        </div>
        <MixedSelectDropdown
          items={menuItems}
          name="deliverable-move-content-dropdown"
          withRemovable
          withIcons
          withTags
          withTruncate
          placeholder={__t(`${msgKey}.dropdown_placeholder`)}
          onItemsToggle={(updatedItems, data, selectedItem) => onChangeSelectedDeliverable(selectedItem)}
          onItemsRemove={(updatedItems, data, selectedItem) => onChangeSelectedDeliverable(selectedItem)}
          onItemsRemoveAll={() => onChangeSelectedDeliverable()}
          className="deliverable-move-content__select"
        />
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className="deliverable-move-content__main">
        {this.renderCloseIcon()}
        {this.renderMediaItems()}
        {this.renderMenuItems()}
        {this.renderFooter()}
      </div>
    );
  }
}

export default DeliverableMoveContent;
